import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const BoostSolidIconWhite = (
  props: Omit<PosIconProps, 'viewBox' | 'fill' | 'stroke'>
) => {
  return (
    <SvgWrapper
      viewBox="0 0 56 56"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28" r="28" fill="white" />
      <g filter="url(#filter0_d_5080_72587)">
        <path
          d="M25.5537 14.6272C27.7745 11.5714 32.6078 13.1011 32.666 16.8782L32.7539 22.5891H36.9873C40.1799 22.5891 42.0415 26.1938 40.1934 28.7971L30.7979 42.0305C28.5804 45.154 23.6612 43.5856 23.6611 39.7551V34.0559H19.1523C15.9401 34.0558 14.0836 30.4124 15.9717 27.8137L25.5537 14.6272ZM31.0273 16.9036C30.9934 14.7003 28.1744 13.8076 26.8789 15.5901L17.2969 28.7766L17.2471 28.8479C16.2457 30.3343 17.2743 32.3525 19.0654 32.4163L19.1523 32.4182H24.3164C24.8589 32.4185 25.2986 32.8581 25.2988 33.4006V39.7551L25.3008 39.8586C25.3866 41.983 28.1006 42.8486 29.4004 41.1663L29.4619 41.0823L38.8574 27.8479C39.9184 26.3531 38.8832 24.2928 37.0742 24.2288L36.9873 24.2278H32.1084L32.0586 24.2258C31.5614 24.2009 31.1606 23.8066 31.1279 23.3098L31.126 23.26L31.0273 16.9036ZM27.7686 17.4329C28.2635 16.7395 29.3564 17.0898 29.3564 17.9417V25.0549C29.3564 25.5385 29.7489 25.9309 30.2324 25.9309H36.2559C36.9678 25.9309 37.3822 26.7352 36.9688 27.3147L28.4873 39.1936C27.9923 39.8869 26.8994 39.5367 26.8994 38.6848V31.5715C26.8993 31.088 26.507 30.6965 26.0234 30.6965H20C19.288 30.6965 18.8735 29.8913 19.2871 29.3118L27.7686 17.4329Z"
          fill="#121212"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_5080_72587"
          x="5.21387"
          y="3"
          width="45.7119"
          height="50.6938"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5080_72587"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5080_72587"
            result="shape"
          />
        </filter>
      </defs>
    </SvgWrapper>
  );
};
